// Menü ↔ yetki eşleşmesinin TEK doğruluk kaynağı.
//
// Yetkiler TEKN tablosundaki YETK_WEB_2..YETK_WEB_20 kolonlarından gelir (YETK_WEB_1 = web'e
// giriş yetkisi, login sorgusunda kullanılır ve buraya hiç ulaşmaz). Backend numaraları ham
// olarak döner (`yetkiler` = { "2": true, "3": false, ... }), hangi numaranın hangi menüye
// karşılık geldiği yalnızca burada tanımlıdır.
//
// Yeni ekran eklerken: boştaki bir numarayı (10..20) buradaki listeye ekle, sayfayı yaz,
// App.js'e route'unu koy. Backend'de değişiklik gerekmez.
// Menü çubuğundaki ANA MENÜLER ve altlarındaki ekranlar burada tanımlı (2026-09-06 yatay
// menüye geçiş, 2026-09-08 birden fazla ana menü).
//
// Bir ekranın `menu` alanı hangi ana menünün altında görüneceğini söyler; yazılmazsa
// ANA_MENU_VARSAYILAN kullanılır. Ana menülerin çubuktaki SIRASI ANA_MENULER dizisidir.
// İsteğe bağlı `grup` alanı verilirse aynı gruptakiler ardışık listelenir ve gruplar
// arasına ayraç çizilir.
export const ANA_MENU_VARSAYILAN = 'Seçenekler';
export const ANA_MENULER = ['Seçenekler', 'Randevu Modülü', 'Banko Modülü', 'Anlaşmalı Kurum'];
export const MENULER = [
  // Yapay Zeka Asistanı yetkisizdir — giriş yapan herkes görür (kullanıcı talebi: 2026-08-20).
  { path: '/yapay-zeka',           icon: '🤖', label: 'Yapay Zeka Asistanı' },
  // Sesli hatırlatıcı — TEKN.YETK_WEB_21, dört şubede açıldı (kullanıcı talebi: 2026-09-18).
  { path: '/kisisel-asistan',      icon: '🎙️', label: 'Kişisel Asistan',      yetki: 21 },
  { path: '/izin',                 icon: '📝', label: 'İzin Yönetimi',        yetki: 2 },
  { path: '/shift',                icon: '🗓️', label: 'Shift Yönetimi',       yetki: 3 },
  { path: '/etkinlik-hasta-kaydi', icon: '🎪', label: 'Etkinlik Hasta Kaydı', yetki: 5 },
  { path: '/reklam-yonetimi',      icon: '📢', label: 'Reklam Yönetimi',      yetki: 6 },
  { path: '/harcama-kaydi',        icon: '💳', label: 'Harcama Kaydı ( Sınırlı )', yetki: 9 },
  { path: '/harcama-gelismis',     icon: '📒', label: 'Harcama Kaydı Gelişmiş', yetki: 10 },
  // Call Center'ın yetkisi YETK_WEB'de değil, YETK_CALL_1'de (aşağıdaki CALL sabitleri).
  { path: '/call-center',          icon: '📞', label: 'Call Center',            call: 1 },
  // Bu ekranın yetkisi ÜÇÜNCÜ aileden: TEKN.YETK21 (kullanıcı talebi: 2026-09-05).
  { path: '/resmi-tatiller',       icon: '📅', label: 'Resmi ve Dini Tatiller',  klasik: 21 },
  // YETK_WEB_8, "Randevu Ver" adındaki boş yer tutucu ekranındı; o menü kaldırılınca boşta
  // kaldı ve gerçek randevu ekranına verildi (kullanıcı kararı: 2026-09-07). Önce TEKN.YETK37
  // kullanılıyordu, ama o kolon VB6 modülleriyle ORTAK; web'e özel bir yetki olması için
  // YETK_WEB ailesine taşındı.
  // Ana menü: Randevu Modülü (kullanıcı talebi: 2026-09-20).
  { path: '/randevu-ekrani',       icon: '🗓️', label: 'Randevu Ekranı', menu: 'Randevu Modülü', yetki: 8 },
  { path: '/randevu-listesi',      icon: '📋', label: 'Randevu Listesi', menu: 'Randevu Modülü', yetki: 7 },
  // Randevu Modülü'nün en altında (kullanıcı talebi: 2026-09-20). Menüdeki sıra bu dizinin sırasıdır.
  { path: '/uygun-randevu',        icon: '🔎', label: 'Uygun Randevu Bulucu', menu: 'Randevu Modülü', yetki: 4 },
  // 4. ekran: ertesi günün randevularına hatırlatma SMS'i (VB6 H_SMS_FORM.frm) — 2026-09-21.
  // Yetkisi Randevu Ekranı ile ortak (YETK_WEB_8).
  { path: '/hatirlatma-sms',       icon: '✉️', label: 'Hatırlatma SMS', menu: 'Randevu Modülü', yetki: 8 },
  // Toplu SMS (VB6 SERBEST_SMS.frm; VB6'daki "Serbest SMS" adı kullanıcı isteğiyle değişti) — 2026-09-21.
  { path: '/toplu-sms',            icon: '📣', label: 'Toplu SMS', menu: 'Randevu Modülü', yetki: 8 },

  // --- Banko Modülü (kullanıcı talebi: 2026-09-20) — VB6 Banko modülünün web karşılığı.
  // Hasta Kayıt: VB6 KAYT2.frm; CHK (KARTKOD=1) hasta kartları. Yetki: boştaki YETK_WEB_11.
  { path: '/hasta-kayit', icon: '🧑‍⚕️', label: 'Hasta Kayıt', menu: 'Banko Modülü', banko: 1 },
  // Hasta Kabul: VB6 KABUL.frm; açık kabuller (KABUL tablosu). Ekrana giriş yine VEZNE1,
  // ekran İÇİNDEKİ işlem yetkileri VB6 ile birebir (sunucudan gelir) — 2026-09-21.
  { path: '/hasta-kabul', icon: '🧾', label: 'Hasta Kabul', menu: 'Banko Modülü', banko: 1 },
  // Hasta Cari Hesapları: VB6 CAR_H.frm; CHI cari hareketleri, tahsilat/ödeme — 2026-09-21.
  { path: '/hasta-cari', icon: '💳', label: 'Hasta Cari Hesapları', menu: 'Banko Modülü', banko: 1 },
  // Hasta e-Fatura: VB6 ESMM_H_NEW.frm; REFERANS (NE=1) hasta payı faturaları — 2026-09-21.
  { path: '/hasta-efatura', icon: '🧾', label: 'Hasta e-Fatura', menu: 'Banko Modülü', banko: 1 },

  // --- Anlaşmalı Kurum ---
  // Yetki: TEKN.YETK45 — klasik (VB6 ile ortak) aile (kullanıcı kararı: 2026-09-08).
  { path: '/kurum-faturalari',     icon: '🧾', label: 'Kurum Faturaları', menu: 'Anlaşmalı Kurum', klasik: 45 },
];

// CALL CENTER YETKİLERİ — AYRI kolon ailesi: TEKN.YETK_CALL_1..7 (kullanıcı talebi:
// 2026-09-03). YETK_WEB_* kolonlarına DOKUNULMADI: onlar FizyofiPlus menü yetkileridir,
// kimde hangisinin açık olduğunu kullanıcı ayarlar ve elimizde kaynağı olmayan başka
// Dr.Plazma modülleri de o kolonları kullanıyor olabilir.
//
// Login yanıtındaki `callYetkileri` alanından okunur; sunucu da aynı numaraları
// [CallYetki(n)] ile zorunlu kılar. Buradaki kontroller sadece arayüzü sadeleştirir.
export const CALL = {
  GIRIS: 1,          // Call Center ekranına giriş (menüyü de bu belirler)
  SMS_GONDER: 2,     // SMS gönderme
  GUNCELLE: 3,       // çağrı sonucunu kaydetme
  YENI_KAYIT: 4,     // yeni çağrı kaydı ekleme
  SIL: 5,            // kayıt silme (yalnızca elle girilenler)
  ALAN_DUZELT: 6,    // ad / telefon / son telefon düzeltme
  EXCEL: 7,          // Excel'e aktarma
};

export const oturumKullanicisi = () => {
  try {
    return JSON.parse(localStorage.getItem('kullanici') || '{}');
  } catch {
    return {};
  }
};

// no verilmezse (Panel gibi yetkisiz menüler) her zaman true.
export const yetkiVar = (no) => {
  if (no == null) return true;
  const y = oturumKullanicisi().yetkiler;
  return !!(y && y[String(no)]);
};

// KLASİK Dr.Plazma yetkileri: TEKN.YETK<no> (YETK_WEB_* / YETK_CALL_* DEĞİL).
// Bu kolonlar VB6 modülleriyle ORTAKTIR — web yalnızca okur, değerlerini kullanıcı yönetir.
export const klasikYetkiVar = (no) => {
  if (no == null) return true;
  const y = oturumKullanicisi().klasikYetkiler;
  return !!(y && y[String(no)]);
};

// BANKO yetkileri: TEKN.VEZNE1/2/3 — VB6 Banko modülündeki ANA.YETVEZNE1/2/3 ile aynı kolonlar
// (kullanıcı kararı: 2026-09-20). 1 = ekrana giriş + yeni kayıt · 2 = değiştir · 3 = sil/iptal.
export const bankoYetkiVar = (no) => {
  if (no == null) return true;
  const y = oturumKullanicisi().bankoYetkileri;
  return !!(y && y[String(no)]);
};

export const callYetkiVar = (no) => {
  if (no == null) return true;
  const y = oturumKullanicisi().callYetkileri;
  return !!(y && y[String(no)]);
};

// Bir menü üç yetki ailesinden birine bağlıdır: yetki = TEKN.YETK_WEB_x,
// call = TEKN.YETK_CALL_x, klasik = TEKN.YETKx, banko = TEKN.VEZNEx.
// Verilmeyen aile kısıt getirmez.
export const menuYetkisiVar = (m) =>
  yetkiVar(m.yetki) && callYetkiVar(m.call) && klasikYetkiVar(m.klasik) && bankoYetkiVar(m.banko);

export const gorunenMenuler = () => MENULER.filter(menuYetkisiVar);

// Menü çubuğu için ana menü ağacı.
//
// 2026-09-21'den itibaren menüler yetkiye göre GİZLENMEZ, PASİFLEŞTİRİLİR (kullanıcı kararı):
// "yazılımda neler var herkes görsün ama giremesin". Her madde `yetkili` bayrağıyla döner;
// içinde tek bir yetkili ekran olmayan ana menü de görünür ama başlığı soluk çizilir.
// Erişim engeli arayüzde değil, sunucuda ve App.js'teki YetkiliRoute'tadır.
export const menuAgaci = () =>
  ANA_MENULER
    .map(ad => {
      const maddeler = MENULER
        .filter(m => (m.menu || ANA_MENU_VARSAYILAN) === ad)
        .map(m => ({ ...m, yetkili: menuYetkisiVar(m) }));
      return { ad, maddeler, yetkili: maddeler.some(m => m.yetkili) };
    })
    .filter(x => x.maddeler.length > 0);
